import { Store } from "pullstate";

const initialState = (() => {
    const raw = localStorage.getItem('drukre_favStore');
    let parsed: { total: number; product_ids: string[] } = {
        total: 0,
        product_ids: []
    };
    try {
        parsed = raw ? JSON.parse(raw) : {};
    } catch {
        parsed = {
            total: 0,
            product_ids: []
        };
    }
    return {
        total: parsed.total ?? 0,
        product_ids: Array.isArray(parsed.product_ids) ? parsed.product_ids as string[] : []
    };
})();

export const FavouritesStore = new Store(initialState);

export const addToFavourites = (marker: any) => {
    FavouritesStore.update(s => {
        if (s?.product_ids && s.product_ids.find((id: string) => id === `${marker?.sale_type}/${marker?.id}`)) {
            s.product_ids = s.product_ids.filter((id: string) => id !== `${marker?.sale_type}/${marker?.id}`);
        } else {
            s.product_ids = [ ...s.product_ids, `${marker?.sale_type}/${marker?.id}` ];
        }
    });

    localStorage.setItem('drukre_favStore', JSON.stringify(FavouritesStore.getRawState()));
}
